<template src="./Edit.html"></template>

<script>
import { showAlert } from "@/utils/helpers";

export default {
  props: {
    itemId: {
      type: Number,
      required: true,
    },
     doctorId: {
      type: Number,
      required: true,
    },
  },
  created() {
    this.$store.dispatch("lookups/getAllItemPriceList", "صيدلية");
    this.$store.dispatch("doctorPrescriptions/getForEdit", { id: this.itemId, doctorId: this.doctorId }).then((res) => {
      this.vm = res
      this.vm.patientId = res.id;
      this.vm.fileNo = res.fileNo;
      this.vm.fullName = res.fullName;
      this.vm.appointmentDate = res.appointmentDate;
      this.vm.items = res.items;
    });
  },
  computed: {
    itemPriceList() {
      return this.$store.state.lookups.itemPriceList || [];
    },
    doctors() {
      return [
        ...this.$store.state.lookups.doctors];
    },

  },
  data() {
    return {
      appointments: [],
      patients: [],
      formDialog: false,
      vm: {
        doctorId: null,
        patientId: null,
        appointmentDate: null,
        items: []
      },
      medicine: {
        serviceName: null,
        quantity: null,
      },
      indexItem: null,
      editFlag: false,
      headers: [
        { text: 'اسم الدواء', value: 'serviceName' },
        { text: 'الكمية', value: 'quantity' },
        { text: 'الاجراءات', value: 'actions', sortable: false },
      ],
    };
  },
  methods: {
    confirm() {
      if (this.vm.items.length == 0) {
        showAlert(`يجب ادخال عنصر واحد على الاقل`);
        return false;
      }
      this.$store
        .dispatch("doctorPrescriptions/edit", { id: this.itemId, payload: this.vm })
        .then(() => {
          this.back();
        })
        .catch(() => { });

    },

    AddItem() {
      if (this.medicine.serviceName == null) {
        showAlert(`يجب اختيار الدواء `);
        return false;
      } else if (this.medicine.quantity == null) {
        showAlert(`يجب ادخال الكمية   `);
        return false;
      }

      let isFound = false;
      this.vm.items.forEach(element => {
        if (element.serviceName == this.medicine.serviceName) {
          showAlert(`الدواء مضاف مسبقا`);
          isFound = true;
        }
      });

      if (isFound) {
        showAlert(`الدواء مضاف مسبقا`);
        return false;
      }
      let medicine = this.itemPriceList.find(x => x.itemName == this.medicine.serviceName);
      this.vm.items.push({
        serviceName: this.medicine.serviceName,
        serviceCode: medicine.itemCode,
        quantity: this.medicine.quantity,
        price: medicine.price
      });

      this.medicine.serviceName = null;
      this.medicine.quantity = null;
      // this.stock = [];

      this.$refs.form.reset();
    },
    removeItem(index) {
      this.vm.items.splice(index, 1);
    },
    back() {
      this.$emit("back");
    },
  },
};
</script>